// extracted by mini-css-extract-plugin
export default {"canNotVoteButton":"EntryDetails_canNotVoteButton__eCaut","wrapper":"EntryDetails_wrapper__SjVnm","edClipboardButton":"EntryDetails_edClipboardButton__lDuHv"};